import { Toggle as DfhToggle } from '@designsforhealth/dfh-react-components'
import styled from 'styled-components'

export const Toggle = styled(DfhToggle)`
  && {
    // prevent progress spinner from being displayed too far from the toggle
    // and avoid an excessively large click target
    max-width: 350px;
    input:checked + label .slider {
      background-color: ${({ theme }) => theme.colors.royalBlue.shade500};
    }
    label > span {
      display: flex;
      align-items: center;
      // increase width
      flex: 1;
    }
  }
`

export const DispensaryToggle = styled(Toggle)`
  margin-bottom: var(--dispensing-option-spacing);
`

export const Description = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-size: 16px;
    line-height: 1.17;
  }
`

export const Label = styled.div`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-size: 14px;
    margin: 0;
    flex: 1;
  }
`
